import React, { useState } from 'react';
import { Button } from 'primereact/button';
import TaxDocumentProcessor from './ChatBot/TaxDocumentProcessor';
import '../css/KnowledgeBase.css';

function KnowledgeBase() {
    const [showTaxProcessor, setShowTaxProcessor] = useState(false);

    const faqData = [
        {
            question: "Who is ProfiTree for?",
            answer: "ProfiTree is designed for both long-term investors and active traders who manage their own portfolios. Whether you're a buy-and-hold investor looking to optimize tax efficiency or an active trader seeking to minimize tax impact on frequent trades, our platform provides the tools you need to maximize after-tax returns.",
            example: "Our platform works equally well for investors who trade monthly and those who rebalance quarterly. The key is that you're managing your own portfolio and want to optimize your tax efficiency."
        },
        {
            question: "What is tax-loss harvesting and how does ProfiTree help?",
            answer: "Tax-loss harvesting is a strategy where you sell investments at a loss to offset taxable gains, reducing your overall tax bill. ProfiTree automatically identifies these opportunities in your portfolio and provides actionable recommendations. You maintain full control over your trades while we guide you to potential tax savings.",
            example: "For example, if you bought a stock for $1,000 and it dropped in value to $700, you could sell it to realize a $300 loss. This loss can then offset $300 of taxable gains from other investments, lowering your overall tax burden."
        },
        {
            question: "How does ProfiTree's guaranteed savings work?",
            answer: "Our Growth plan ($199/year) guarantees $2,000 minimum tax savings or you get a full refund. We're confident in our platform's ability to identify tax-saving opportunities. If you don't achieve the guaranteed savings, we'll refund your entire annual subscription - no questions asked.",
            example: "If you're in the 22% tax bracket and we help you harvest $9,091 in losses, that's $2,000 in tax savings. If we can't help you achieve at least $2,000 in savings, you get your $199 back."
        },
        {
            question: "What's the difference between your pricing tiers?",
            answer: "Free: For portfolios under $100K with basic tax optimization tools. Growth: $199/year for portfolios $100K-$1M with advanced features and $2,000 savings guarantee. Enterprise: Custom pricing for portfolios above $1M or financial advisors with white-label solutions and dedicated support.",
            example: "A $300K portfolio would use the Growth tier, getting advanced features like priority support and custom feature requests, while a $50K portfolio starts free with core tax optimization tools."
        },
        {
            question: "How does the demo mode work?",
            answer: "Try our full platform with sample data to see how ProfiTree works. Click 'Try Demo Mode' to access a pre-populated dashboard with realistic portfolio scenarios. Experience all features including tax-loss harvesting recommendations, wash sale detection, and tax impact calculations without linking your real accounts.",
            example: "The demo shows you a sample portfolio with $150K in assets, various positions with gains and losses, and realistic tax optimization opportunities so you can see exactly how ProfiTree would work with your own portfolio."
        },
        {
            question: "What brokerage accounts does ProfiTree support?",
            answer: "ProfiTree connects to major brokerages including Fidelity, Schwab, E*TRADE, Robinhood, and more through our secure SnapTrade integration. We provide read-only access to your portfolio data - we never make trades or move money. You can link multiple accounts for comprehensive tax optimization.",
            example: "You can link your Fidelity 401(k) rollover account, your Schwab individual brokerage, and your Robinhood account all in one place to get a complete view of your tax optimization opportunities across all your investments."
        },
        {
            question: "How secure is my financial data?",
            answer: "We use bank-level encryption and connect via SnapTrade (a YC-backed, Plaid-like provider). ProfiTree only has read-only access to your portfolio data and never stores your brokerage credentials. Your data is encrypted in transit and at rest, and we follow strict security protocols.",
            example: "Even if someone gained access to your ProfiTree account, they could only see your portfolio positions and could never make trades, withdraw money, or access your actual brokerage accounts."
        },
        {
            question: "What is a wash sale and how does ProfiTree help avoid them?",
            answer: "A wash sale occurs when you sell a security at a loss and buy the same or substantially identical security within 30 days, which disallows the tax loss. ProfiTree tracks your trading activity and alerts you to potential wash sales, helping you maintain proper timing for maximum tax benefits.",
            example: "If you sell Apple stock at a loss on Monday and buy Apple stock again on Friday of the same week, you've created a wash sale. The $500 loss you thought you realized is now disallowed for tax purposes."
        },
        {
            question: "How accurate are the tax savings calculations?",
            answer: "Our calculations are based on current tax laws and your actual portfolio data. We factor in your cost basis, holding periods, and tax brackets to provide accurate estimates. However, actual tax savings depend on your specific tax situation - we recommend consulting with a tax professional for final decisions.",
            example: "We calculate that harvesting a $5,000 loss could save you $750-$1,100 in taxes depending on whether you're in the 15% or 22% capital gains bracket, but your actual savings may vary based on your total income and other deductions."
        },
        {
            question: "Can I use ProfiTree with my existing investment strategy?",
            answer: "Absolutely! ProfiTree works with any investment strategy. We don't force you into specific ETFs or change your asset allocation. Instead, we analyze your current holdings and provide recommendations to optimize tax efficiency while maintaining your investment philosophy and goals.",
            example: "Whether you're a value investor, growth investor, dividend investor, or sector rotator, ProfiTree will work with your existing portfolio and strategy to identify tax optimization opportunities without changing your core investment approach."
        },
        {
            question: "How do I get started with ProfiTree?",
            answer: "Start by trying our demo mode to see the platform in action. When ready, sign up for a free account and link your brokerage accounts securely. Our onboarding process will guide you through connecting accounts and understanding your tax optimization opportunities. You can start with the free tier and upgrade as needed.",
            example: "The entire process takes about 5 minutes: 1) Try the demo, 2) Sign up for free, 3) Link your brokerage accounts, 4) See your tax optimization opportunities immediately."
        },
        {
            question: "What kind of support do you provide?",
            answer: "We offer comprehensive support including detailed documentation, video tutorials, and email support. Growth and Enterprise users get priority support. For complex tax questions, we recommend consulting with a tax professional, as we focus on providing the tools and insights while you make the final decisions.",
            example: "Our support team typically responds within 4 hours during business hours, and Growth/Enterprise users get priority response times. We also have a comprehensive knowledge base with step-by-step guides for all features."
        }
    ];

    return (
        <div className="knowledge-base">

            <h2 className="knowledge-heading">Frequently Asked Questions</h2>
            <div className="faq-list">
                {faqData.map((faq, index) => (
                    <FaqItem key={index} question={faq.question} answer={faq.answer} example={faq.example} />
                ))}
            </div>

            {/* Tax Document Processor Modal */}
            {showTaxProcessor && (
                <TaxDocumentProcessor 
                    onClose={() => setShowTaxProcessor(false)}
                    onComplete={() => {
                        setShowTaxProcessor(false);
                        // Could add success message here if needed
                    }}
                />
            )}
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
                        {/* Tax Document Upload Section */}
                        <div className="tax-upload-section">
                <div className="tax-upload-content">
                    <h2 className="tax-upload-heading">Get Your Free Tax Analysis</h2>
                    <p className="tax-upload-description">
                        Upload your tax documents and receive a comprehensive analysis of your tax optimization opportunities. 
                        Our AI will identify potential tax savings, wash sale violations, and strategic recommendations.
                    </p>
                    <p className="tax-upload-description">
                    </p>
                    <Button 
                        label="Upload Tax Document" 
                        icon="pi pi-upload" 
                        className="tax-upload-button"
                        onClick={() => setShowTaxProcessor(true)}
                        size="large"
                    />
                </div>
            </div>
        </div>
    );
}

function FaqItem({ question, answer, example }) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <div className="faq-item">
            <div className="faq-question" onClick={toggleOpen}>
                <h3>{question}</h3>
                <span>{isOpen ? "-" : "+"}</span>
            </div>
            {isOpen && (
                <div className="faq-content">
                    <p className="faq-answer">{answer}</p>
                    {Array.isArray(example) ? (
                        <div className="faq-example">
                            <strong>Example:</strong>
                            {example.map((line, index) => (
                                <p key={index}>{line}</p>
                            ))}
                        </div>
                    ) : (
                        <p className="faq-example">
                            <strong>Example:</strong> {example}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}



export default KnowledgeBase;
